class IdsController
  panzoomInstance = null

  # !! requires panzoom js lib
  @makeImageZoomable: (image) ->
    return if panzoomInstance

    panzoomInstance = panzoom(image, { smoothScroll: false, maxZoom: 10, minZoom: 1, zoomDoubleClickSpeed: 1, contain: true });

  @zoomIn: ->
    panzoomInstance.smoothZoom(20, 20, 1.25)

  @zoomOut: ->
    panzoomInstance.smoothZoom(20, 20, 0.8)

module.exports = IdsController
